import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './IconChevronRight.module.css';

const IconChevronRight = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="13"
      height="22"
      viewBox="0 0 13 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 11.0009L9.52061e-07 0.11L4.76005e-07 11.0009L0 21.8906L12 11.0009Z"
        fill="white"
      />
      <path
        d="M0.5 22L0.5 21.3926L12 11.0003L0.500001 0.607971L0.500001 -5.02681e-07"
        stroke="var(--colorGrey700)"
      />
    </svg>
  );
};

IconChevronRight.defaultProps = { className: null };

IconChevronRight.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconChevronRight;
